import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { getBank } from '../../api/banks';
import { searchVerifyTickets } from '../../api/verifyTicket';
import { fetchTicketDetail } from '../../api/salesMonitoring';
import TicketViewModal from '../../components/TicketViewModal';
import './BankTicketsView.css';

// Meme ordre que sur le ticket papier (No croissant, toutes loteries confondues,
// puis loterie pour departager) — searchVerifyTickets renvoie par defaut tirage
// puis No (cf. tickets/views.py:VerifyTicketSearchView), pas l'ordre voulu ici.
const sortTickets = (rows) => [...rows].sort((a, b) => {
  if (a.no !== b.no) return (a.no ?? 0) - (b.no ?? 0);
  return a.tirage_code - b.tirage_code;
});

const BankTicketsView = ({ bankId, date, lottery = '0', onBack }) => {
  const [bank, setBank] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  // Fiche ouverte (clic sur une ligne) : boules jouees, gains... (2026-10-11).
  const [openTicketId, setOpenTicketId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    Promise.all([
      getBank(bankId),
      searchVerifyTickets({
        filterType: 'Bank',
        scopeId: bankId,
        date,
        tirageFrom: String(lottery ?? '0') !== '0' ? String(lottery) : undefined,
        tirageUp: String(lottery ?? '0') !== '0' ? String(lottery) : undefined,
      }),
    ])
      .then(([bankData, ticketData]) => {
        if (cancelled) return;
        setBank(bankData);
        setTickets(sortTickets(ticketData));
      })
      .catch(() => { if (!cancelled) setError('Impossible de charger les tickets — verifie que le serveur backend tourne.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [bankId, date, lottery]);

  const utilisateur = tickets.find(t => t.device_serial)?.device_serial || '';

  return (
    <Layout>
      <button className="btv-back-btn" onClick={onBack}>Volver</button>

      <div className="btv-card">
        <div className="btv-card-header">
          <span className="btv-card-title">Tickets per la Banque</span>
        </div>

        <div className="btv-info">
          <div className="btv-info-row">
            <span className="btv-info-label">Banque:</span>
            <span className="btv-info-box">{bank ? `${bank.seq} - ${bank.name}` : ''}</span>
          </div>
          <div className="btv-info-row">
            <span className="btv-info-label">Adresse:</span>
            <span className="btv-info-box btv-info-box-wide">{bank?.address || '.'}</span>
            <span className="btv-info-label btv-info-label-gap">Telephone :</span>
            <span className="btv-info-box">{bank?.phone || '.'}</span>
          </div>
          <div className="btv-info-row">
            <span className="btv-info-label">Utilisateur :</span>
            <span className="btv-info-box btv-info-box-wide">{utilisateur}</span>
          </div>
        </div>

        <div className="btv-table-bar"></div>

        {error && <p className="btv-error">{error}</p>}
        {loading && <p className="btv-loading">Chargement...</p>}

        {!loading && !error && (
          <table className="btv-table">
            <thead>
              <tr>
                <th>Sec.</th>
                <th>Loterie</th>
                <th>Sales Type</th>
                <th>Numero de Ticket</th>
                <th>Montant</th>
                <th>Temp</th>
              </tr>
            </thead>
            <tbody>
              {tickets.map((row) => (
                <tr
                  key={row.id}
                  className="tvm-clickable-row"
                  title="Voir les boules jouees"
                  onClick={() => setOpenTicketId(row.id)}
                >
                  <td>{row.sq ?? '-'}</td>
                  <td>{row.tirage_name} | ( {row.tirage_code} )</td>
                  <td>{row.was_offline ? 'Local' : 'OnLine'}</td>
                  <td><span className="btv-numero">{row.no ?? '-'}</span></td>
                  <td>{Number(row.total_amount).toFixed(2)}</td>
                  <td>{new Date(row.created_at).toLocaleTimeString()}</td>
                </tr>
              ))}
              {tickets.length === 0 && (
                <tr><td colSpan={6} className="btv-empty">Aucun ticket trouvé.</td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {openTicketId != null && (
        <TicketViewModal
          ticketId={openTicketId}
          fetcher={fetchTicketDetail}
          onClose={() => setOpenTicketId(null)}
        />
      )}
    </Layout>
  );
};

export default BankTicketsView;
